import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type StudentDashboardState } from './studentDashboardSlice.types';

export const defaultStudentDashboardState: StudentDashboardState = {
    hasSeenExecEdEligibilityModal: false,
    activePlaylistLocalePackId: null,
    pendingFocusedProjectRequirementIdentifier: null,
    pendingViewProjectFeedbackRequirementIdentifier: null,
    forceExpandedItems: {},
    mobileDrawerShouldHide: false,
};

export const studentDashboardSlice = createSlice({
    name: 'studentDashboard',
    initialState: defaultStudentDashboardState,
    reducers: {
        setHasSeenExecEdEligibilityModal: (state, action: PayloadAction<boolean>) => {
            state.hasSeenExecEdEligibilityModal = action.payload;
        },
        setActivePlaylistLocalePackId: (state, action: PayloadAction<{ localePackId: string | null }>) => {
            state.activePlaylistLocalePackId = action.payload.localePackId;
        },
        setPendingFocusedProjectRequirementIdentifier: (
            state,
            action: PayloadAction<{ requirementIdentifier: string | null }>,
        ) => {
            state.pendingFocusedProjectRequirementIdentifier = action.payload.requirementIdentifier;
        },
        setPendingViewProjectFeedbackRequirementIdentifier: (
            state,
            action: PayloadAction<{ requirementIdentifier: string | null }>,
        ) => {
            state.pendingViewProjectFeedbackRequirementIdentifier = action.payload.requirementIdentifier;
        },
        forceExpandContentItem: (state, action: PayloadAction<{ itemId: string }>) => {
            state.forceExpandedItems[action.payload.itemId] = true;
        },
        resetForceExpandContentItem: (state, action: PayloadAction<{ itemId: string }>) => {
            delete state.forceExpandedItems[action.payload.itemId];
        },
        setMobileDrawerShouldHide: state => {
            state.mobileDrawerShouldHide = true;
        },
        resetMobileDrawerShouldHide: state => {
            state.mobileDrawerShouldHide = false;
        },
    },
});

export const studentDashboardReducer = studentDashboardSlice.reducer;
export const studentDashboardActions = studentDashboardSlice.actions;
